// extracted by mini-css-extract-plugin
export default {"refresh":"ConnectionTasksComponent_refresh__0z4PH"};